import * as Sentry from "@sentry/nextjs";

type APPS = 'pickleball' | 'tournament' | 'clubs' | 'team-leagues' | 'checkout' | 'brackets' | 'brackets-team-leagues' | 'tiny-url' | 'deeplinks' | 'gamemaker' | 'manage' | 'contact-form';

export interface SharedSentryInitOptions {
  app: APPS
  sentryConfig?: Partial<Sentry.BrowserOptions | Sentry.NodeOptions | Sentry.EdgeOptions>
}

// Client init
export const initSentryClient = (options: SharedSentryInitOptions) => {
  Sentry.init({
    ...options.sentryConfig,
    beforeSend(event) {
      if (
        event.exception?.values?.some(
          (e) =>
            e.value?.includes("Non-Error promise rejection captured with") ||
            e.value?.includes("Object Not Found Matching Id")
        )
      ) {
        return null;
      }

      event.tags = {
        ...event.tags,
        app: options.app,
        errorSource: "client",
      };
      return event;
    },
  });
};

// Server init
export const initSentryServer = (options: SharedSentryInitOptions) => {
  Sentry.init({
    ...options.sentryConfig,
    beforeSend(event) {
      event.tags = {
        ...event.tags,
        app: options.app,
        errorSource: "server",
      };
      return event;
    },
  });
};